import React, { Component } from "react";
import { Flex } from "rebass";
import ContainerDimensions from "react-container-dimensions";
import "./index.css";
import { connect } from "../../utils";

const defaultBackground = {
  backgroundColorParent: "rgba(255,255,255,0)",
  backgroundColor: "rgba(255,255,255,0)",
  backgroundImage: {
    url: "",
    urlMobile: ""
  },
  bgProps: {
    size: "cover",
    position: "center",
    repeat: "no-repeat",
    ratio: 1.8
  },
  isBackgroundImage: false,
  padding: "0px",
  width: {
    type: "%",
    contentWidth: 100
  },
  alignment: {
    vertical: "center",
    horizontal: "center"
  }
};

class Content extends Component {
  renderWithColor(
    values,
    bgColor,
    contentPadding,
    alignment,
    children,
    width,
    bgColorParent
  ) {
    let widthContent = `${width.contentWidth}${width.type}`;
    return (
      <ContainerDimensions>
        {({ width, height }) => {
          let classes = values.className;
          if (width <= 320) {
            classes = "mobile";
            widthContent = 1;
          }
          return (
            <div className={classes} style={{ display: "flex" }}>
              <div
                style={{
                  padding: contentPadding,
                  display: "flex",
                  flex: 1,
                  backgroundColor: bgColorParent
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    alignItems: alignment.vertical,
                    justifyContent: alignment.horizontal
                  }}
                >
                  <Flex
                    w={[1, widthContent]}
                    column
                    style={{ backgroundColor: bgColor }}
                  >
                    {children}
                  </Flex>
                </div>
              </div>
            </div>
          );
        }}
      </ContainerDimensions>
    );
  }

  renderWithImage(
    values,
    bgColor,
    contentPadding,
    alignment,
    children,
    width,
    bgColorParent
  ) {
    //  console.log(values.isBackgroundImage);
    let widthContent = `${width.contentWidth}${width.type}`;
    const srcMobile =
      values.backgroundImage.urlMobile || values.backgroundImage.url || "";
    const srcDesktop =
      values.backgroundImage.url || values.backgroundImage.urlMobile || "";
    let important = {
      backgroundImage: `url("${srcDesktop}")`,
      backgroundSize: values.bgProps.size,
      backgroundPosition: values.bgProps.position,
      backgroundRepeat: values.bgProps.repeat
    };

    return (
      <ContainerDimensions>
        {({ width, height }) => {
          let myWidth = width;
          const columnClassName = values.className;

          if (columnClassName) {
            const trimClassName = columnClassName.replace(/\s/g, "");
            if (trimClassName === "col-xs-12col-lg-6col-md-6") {
              myWidth = width / 2;
            } else if (trimClassName === "col-xs-12col-md-4col-lg-4") {
              myWidth = width / 3;
            } else if (trimClassName === "col-xs-12col-md-3col-lg-3") {
              myWidth = width / 4;
            } else if (trimClassName === "col-xs-12col-md-9col-lg-9") {
              myWidth = (width * 3) / 4;
            }
          }
          let minHeight = myWidth / values.bgProps.ratio;
          if (width < 768) {
            important.backgroundImage = `url("${srcMobile}")`;
            minHeight = width;
          }
          let classes = values.className;
          if (width <= 320) {
            classes = "mobile";
            minHeight = 320;
            widthContent = 1;
          }
          return (
            <div className={classes} style={{ display: "flex" }}>
              <div
                style={{
                  padding: contentPadding,
                  display: "flex",
                  flex: 1,
                  backgroundColor: bgColorParent
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    alignItems: alignment.vertical,
                    justifyContent: alignment.horizontal,
                    ...important,
                    minHeight: minHeight
                  }}
                >
                  <Flex
                    w={[1, widthContent]}
                    column
                    style={{ backgroundColor: bgColor }}
                  >
                    {children}
                  </Flex>
                </div>
              </div>
            </div>
          );
        }}
      </ContainerDimensions>
    );
  }

  render() {
    const { id, layoutState, children } = this.props;
    // const {values} = layoutState.getItemJS(id).props;
    const { parent } = layoutState.getItemJS(id);
    const parentContent = layoutState.getItemJS(parent.id);
    const column = parentContent.children.indexOf(`${id}`);
    const { content } = parentContent.props;
    // const { alignment } = parentContent.props.values;
    const { values } = content[column].props;
    const contentPadding = values.padding
      ? values.padding
      : defaultBackground.padding;
    const bgColor = values.backgroundColor
      ? values.backgroundColor
      : defaultBackground.backgroundColor;
    const bgColorParent = values.backgroundColorParent
      ? values.backgroundColorParent
      : defaultBackground.backgroundColorParent;
    const contentWidth = values.width ? values.width : defaultBackground.width;
    const alignContent = values.alignment
      ? values.alignment
      : defaultBackground.alignment;

    const ViewContent = values.isBackgroundImage
      ? this.renderWithImage(
          values,
          bgColor,
          contentPadding,
          alignContent,
          children,
          contentWidth,
          bgColorParent
        )
      : this.renderWithColor(
          values,
          bgColor,
          contentPadding,
          alignContent,
          children,
          contentWidth,
          bgColorParent
        );

    return ViewContent;
  }
}
export default connect("layoutState")(Content);



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/Content.js